module.exports = __webpack_public_path__ + "static/media/coronavirus.f9c2b1a0.svg";